























import wrappers from '@/mixins/wrappers'
import { Location } from 'vue-router'
import { PropOptions } from 'vue'

export default wrappers.extend({
  name: 'WrappedLink',
  props: {
    to: [Object, String] as PropOptions<Location | string>,
    inline: {
      type: Boolean,
      default: false
    },
    external: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    keydown (event: KeyboardEvent) {
      const keyCodes = [13, 32]
      if (keyCodes.includes(event.keyCode)) {
        this.action()
        event.preventDefault()
      }
    },
    async action () {
      const target = this.$refs['wrapped-content'] as HTMLAnchorElement
      if (target) {
        target.blur()
      }
      this.$emit('click')
      if (!this.external) {
        await this.navigate(this.to)
      }
    }
  }
})
